/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PosCatalogDto } from '../../models/pos-catalog-dto';

export interface PosCatalogControllerGetCatalog$Params {
}

export function posCatalogControllerGetCatalog(http: HttpClient, rootUrl: string, params?: PosCatalogControllerGetCatalog$Params, context?: HttpContext): Observable<StrictHttpResponse<PosCatalogDto>> {
  const rb = new RequestBuilder(rootUrl, posCatalogControllerGetCatalog.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosCatalogDto>;
    })
  );
}

posCatalogControllerGetCatalog.PATH = '/pos/catalog';
